$(document).ready(function () {
  // ============ Product Page JS Fit and Fabric Start ====================
  $(document).on("click",".fit-and-fabric-title",function(){
    $(this).toggleClass('active');
    $(this).closest(".fit-and-fabric-wrapper").find(".fit-and-fabric-accordion").slideToggle();
  });
  // ============ Product Page JS Fit and Fabric End ====================
  
  // ============= USP Bar JS Start ====================
  $('.service-icon-text-slider').owlCarousel({
    nav: true,
    dots: false,
    loop: false,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 5000,
    rewind: true,
    navText: [
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5033 15.808L9.69531 12L13.5033 8.19199V15.808Z" fill="black"/>
      </svg>`,
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4967 15.808L14.3047 12L10.4967 8.19199V15.808Z" fill="black"/>
      </svg>`
    ],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 3
      }
    }
  });
  // ============= USP Bar JS End ====================
  
  // ============= Size Guide JS Start ====================
  var sizeGuideInterval = setInterval(function () {
    if($(".tfc-fitrec-product").length > 0 && $(".size-guide-button").length > 0){
        $('.size-guide-button').insertAfter('#tfc-widget');
       clearInterval(sizeGuideInterval);
    }
  }, 100);
  $(document).on("click",".size-guide-button", function () {
    $(".sizing-chart-modal-link").trigger("click");
  });
  // ============= Size Guide JS End ====================
  
  // ============= Product Page Swatch JS Start ====================
  // Function to update the limited edition text with the data-color-name attribute
  function updateLimitedEditionText(item) {
    var variantProductItemPrint = item.attr("data-color-name");
    item
      .parents(".variant-swatch-products")
      .find(".limited-edition-text h4 span")
      .html(variantProductItemPrint);
  }

  // Function to clear the limited edition text
  function clearLimitedEditionText(item) {
    item
      .parents(".variant-swatch-products")
      .find(".limited-edition-text h4 span")
      .html("");
  }

  // Initial update for the active item on page load
  var activeItem = $(".variant-product-item.active");
  if (activeItem.length) {
    updateLimitedEditionText(activeItem);
  }

  // Update on mouseenter
  $(document).on("mouseenter", ".variant-product-item", function () {
    updateLimitedEditionText($(this));
  });

  // Reset on mouseleave
  $(document).on("mouseleave", ".variant-product-item", function () {
    // Clear the text
    clearLimitedEditionText($(this));

    // Restore the text based on the active item
    if (activeItem.length) {
      updateLimitedEditionText(activeItem);
    }
  });
  // ============= Product Page Swatch JS End ===================
  
  // ============= Product Page button JS Start ===================
  
  var $priceContainer = $('.price-per-item__container');
  var $productForm = $('product-form');

  if ($priceContainer.length && $productForm.length) {
    $productForm.append($priceContainer);

  }
  // ============= Product Page button JS End ===================


  // ============= Collection Page Quick View JS Start ===================

   function moveProductTitle() {
    // Run this only on collection template pages
    if ($('body').hasClass('template-collection')) {
      // Target key elements inside the quickview
      var $title = $('.quick-add-modal__content div.product__title');
      var $price = $('.quick-add-modal__content .price');
      // var $shoppay = $('.quick-add-modal__content .installment');
      var $croppedVersion = $('.quick-add-modal__content .our-cropped-version');
      var $storeAvailability = $('.quick-add-modal__content product__section-content__block--pickup_availability');
      var $productAdd = $('.quick-add-modal__content .product-form'); 
      
      // Define mobile and desktop containers to move elements into
      var $mobileTarget = $('.quick-add-modal__content .product-section-header-content');
      var $desktopTarget = $('.quick-add-modal__content .product__info-container');
      console.log("$mobileTarget ",$mobileTarget.length);
      // Get current screen width
      var screenWidth = $(window).width();
      // Mobile layout: move title, price, etc. into mobile container
      if (screenWidth <= 749) { 
        if ($title.length && !$mobileTarget.find('.product__title').length) {
          $mobileTarget.append($title);
          $mobileTarget.append($price);
          $mobileTarget.append($croppedVersion);
          // $mobileTarget.append($shoppay);
          // $desktopTarget.css("border","none");
        }
        // Move store availability above Add to Cart, only if both exist
        if ($storeAvailability.length && $productAdd.length) {
          $productAdd.before($storeAvailability);
        }     
      } else {
        // Desktop layout: move title, price, etc. into desktop container
        if ($title.length && !$desktopTarget.find('.product__title').length) {
          // $desktopTarget.prepend($price);
          $desktopTarget.prepend($title);
          $title.after($price);
          $price.after($croppedVersion);
          // $desktopTarget.prepend($shoppay);
          // $desktopTarget.css("border","10px solid");
        }
        // Move store availability above Add to Cart, only if both exist
        if ($storeAvailability.length && $productAdd.length) {
          $productAdd.after($storeAvailability);
        }
      }
    }
  }

  
  // Trigger the function when a quickview is opened
  $(document).on('click', '.product-listing__quickview-trigger', function () {
    // Poll until modal content and target containers are available
    const interval = setInterval(() => {
      const $content = $('.quick-add-modal__content .product-section-header-content');
      if ($content.length) {
        clearInterval(interval);
        tfcapi('calculate');
        moveProductTitle();
      }
    }, 100);
  });
  moveProductTitle();
  
  // Also trigger on window resize to reposition elements accordingly
  $(window).on('resize', function () {
    const $contentResize = $('.quick-add-modal__content .product-section-header-content');
    if ($contentResize.length) {
      moveProductTitle();
    }
  });

  // Use event delegation so it works even if content is loaded dynamically (like in quick view)
  $(document).on('click', '.slideout__trigger-store-availability', function () {
    const $drawer = $('pickup-availability-drawer');
  
    if ($drawer.length) {
      $drawer.attr('open', true).focus(); // Open the drawer
    }
  });
  
  // Close drawer when close button is clicked
  $(document).on('click', '.pickup-availability-drawer-button', function () {
    const $drawer = $('pickup-availability-drawer');
  
    if ($drawer.length) {
      $drawer.removeAttr('open'); // Close the drawer
    }
  });
  
  // Toggle filter dropdown on icon click
  $(document).on("click",".sorticonnew-icon", function () {
     $(this).closest(".collection_filter_dropddown").toggleClass("active");
  });
  
   $(document).on("click",".collection__horizontal-toolbar.mobile .collection-filter-list li", function () {
     let index = $(this).index();
     let $sortbyFilter = $(this).closest("body").find("#SortBy");
     const $option = $sortbyFilter.find("option").eq(index);
     if ($option.length) {
        $sortbyFilter.val($option.val()); // Set the value
        $sortbyFilter[0].dispatchEvent(new Event("input", { bubbles: true })); // Trigger native change
      }
     $(this).closest(".collection_filter_dropddown").removeClass("active");
  });


  // Close dropdown when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".collection_filter_dropddown").length) {
        $(".collection_filter_dropddown").removeClass("active");
    }
  });

  // Wrap PDP title and price in one DIV
  var $titleEl = $('.product__info-wrapper .product__title').first();
  var $priceEl = $('.product__info-wrapper .product-content-price');

  if ($titleEl.length && $priceEl.length) {
    var $wrapper = $('<div class="product-title-price-wrapper"></div>');

    // Insert the wrapper before the title
    $titleEl.before($wrapper);

    // Move both elements inside the wrapper
    $wrapper.append($titleEl);
    $wrapper.append($priceEl);
    $priceEl.show();
  }

  //Navigation redirection code
  $(document).on("click",".header-menu-ajax-click", function () {
    var redirectUrl = $(this).attr("data-redirection");
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  });

  // On search icon click
  $(document).on("click",".inline-search-modal .header__search", function () {
    $('body').addClass('search-modal-open');
  });

  // Close when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.inline-search-modal .header__search,.inline-search-modal .search-modal').length) {
      $('body').removeClass('search-modal-open');
    }
  });

  //show/hide filter bar
  $(document).on("click","#filter--toggle", function () {
    $('body').toggleClass("show-filters");
  });


  // =====================================  Header drawer js Start ====================================
   const $menuDrawer = $('#Details-menu-drawer-container');

  $menuDrawer.on('toggle', function () {
    if (this.open) {
      $('body').addClass('custom-menu-drawer-open');
    } else {
      $('body').removeClass('custom-menu-drawer-open');
    }
  });

   // Programmatically close the menu drawer
    function closeMobileMenuDrawer() {
      $('#Details-menu-drawer-container')[0].removeAttribute('open'); // close drawer
      $('.header__icon--menu').attr('aria-expanded', 'false'); // update hamburger state
    }
  
   $('.custom-menu-close-btn').on('click', function() {
      closeMobileMenuDrawer();
  });

  // =====================================  Header drawer End ====================================

//
});